import React,{forwardRef, useEffect, useState} from 'react'
import ProductFeatureAssociationSetupForm from './ProductFeatureAssociationSetupForm'
import UpdateDrawerInfo from '../../../../../../../../../component/common/UpdateDrawerInfo';
const ProductFeatureAssociationUpdateDrawer = forwardRef((props, ref) => {
    const {
        formValidateError, 
        formData, 
        associatedDate, 
        updateAssociationData,
        isButtonLoader,
        drawerIsOpen
    } = props;


    const [updateInfo, setUpdateInfo] = useState({
        isOpen: '',
        title: '',
        information: ''
    });

    const colmd = updateInfo.isOpen === 'open' ? 'col-md-7' : 'col-md-12'

    useEffect(() => {
        props.isUpdateInfo(updateInfo)
    }, [updateInfo]);

    useEffect(() => {
        if(!drawerIsOpen){
            setUpdateInfo({
                isOpen: 'close',
                title: '',
                information: '',
            })
        }
    },[drawerIsOpen])


    return (
        <>
            <div className='row p-5'>
                <div className={`${colmd}`}>
                    <ProductFeatureAssociationSetupForm
                        formValidateError = {formValidateError}
                        formData={formData}
                        associatedDate={associatedDate}
                        updateAssociationData={updateAssociationData}
                        formActionType={'update'}
                        ref={ref}
                        isButtonLoader={isButtonLoader}
                        isInfoOpenHandler={(data) => 
                            setUpdateInfo({
                                isOpen: data.type,
                                title: data.data.title,
                                information: data.data.info,
                            })
                        }
                    />
                </div>
                {
                    updateInfo.isOpen === 'open' &&
                    <div className={`col-md-5`}>
                        <UpdateDrawerInfo
                            title={updateInfo.title}
                            information={updateInfo.information}
                            infoCloseOnClick={() => 
                                setUpdateInfo({
                                    isOpen: '',
                                    title: '',
                                    information: '',
                                })
                            }
                        />
                    </div>
                }
            </div>
        </>
    )
})
export default ProductFeatureAssociationUpdateDrawer